import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Tooltip } from '@paypalcorp/pp-react';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_checkbox_with_tooltip__-PLEI {\n  display: flex;\n  align-items: center;\n}\n.styles-module_pointer_events__oWspB {\n  pointer-events: none;\n}\n";
var styles = {"checkbox_with_tooltip":"styles-module_checkbox_with_tooltip__-PLEI","pointer_events":"styles-module_pointer_events__oWspB"};
styleInject(css_248z);

var _excluded = ["checkbox_content", "tooltip_content", "disabled"];
function DonateCheckbox(props) {
  var checkbox_content = props.checkbox_content,
    tooltip_content = props.tooltip_content,
    disabled = props.disabled,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(tooltip_content && styles.checkbox_with_tooltip, " ").concat(disabled && styles.pointer_events)
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({
    label: checkbox_content,
    disabled: disabled !== null && disabled !== void 0 ? disabled : false
  }, restProps)), tooltip_content && /*#__PURE__*/React.createElement(Tooltip, {
    disabled: disabled !== null && disabled !== void 0 ? disabled : false,
    description: tooltip_content
  }));
}
DonateCheckbox.propTypes = {
  checkbox_content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  tooltip_content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  name: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  testid: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func
};

export { DonateCheckbox };
